import { AccountInfo } from '@azure/msal-browser';
import {patchData} from './base';

export async function updateDataApi(endpoint: string, reqBody: object,
    accounts: AccountInfo[]) {
    return await patchData(endpoint, reqBody, accounts);
}

export async function updateCompanyDetail(reqBody: object,
    accounts: AccountInfo[]) {
    const res = await patchData('UpdateCompanyDetail', reqBody, accounts);
    return res;
}

export async function updateUserApi(endpoint: string, reqBody: object,
    accounts: AccountInfo[]) {
    return await patchData(endpoint, {...reqBody,
        updatedOn: new Date().toISOString()}, accounts);
}

export async function updateCategoryApi(endpoint: string, reqBody: object,
    accounts: AccountInfo[]) {
    try {
        const {res} = await patchData(endpoint, {
            ...reqBody,
            fileUploaded: undefined,
            updatedOn: new Date().toISOString()
        }, accounts);
        return {res};
    } catch (error: any) {
        return {error};
    }
}
